import axios from 'axios';

const KEY = 'oj7fp6P8mXas8zNN99jJU2FwE3QW26104hsA7okr';

export default axios.create(
  {
      baseURL: 'https://gywftannv7.execute-api.eu-west-1.amazonaws.com/prod',
      headers: {
          'X-Api-Key':  KEY,
          'Content-Type': 'application/json'
        },
      crossDomain: true
  }
); 
